import React from 'react';
import { MONTHS, daysInMonth, toInputDate } from './format';
import { Segmented } from './ui';

const PRESETS = [
    { value: 'today', label: 'Oggi' },
    { value: '7d', label: '7 giorni' },
    { value: '30d', label: '30 giorni' },
    { value: 'month', label: 'Mese' },
    { value: 'year', label: 'Anno' },
];

/**
 * Intervallo di date (inclusivo, fino ad oggi) per un preset.
 */
export function presetRange(preset, today = new Date()) {
    const from = new Date(today);

    switch (preset) {
        case '7d': from.setDate(today.getDate() - 6); break;
        case '30d': from.setDate(today.getDate() - 29); break;
        case 'month': from.setDate(1); break;
        case 'year': from.setMonth(0, 1); break;
        default: break;
    }

    return { from: toInputDate(from), to: toInputDate(today) };
}

const activePreset = (from, to) => (PRESETS.find(p => {
    const range = presetRange(p.value);
    return range.from === from && range.to === to;
}) || {}).value;

/**
 * Filtri unici per tutta la pagina: tutti i grafici usano gli stessi valori.
 * - anno e mese: grafici mensili e giornalieri
 * - giorno: pagamenti per paese (opzionale, di default tutto il mese)
 * - periodo: ricavi, piattaforme e VPN per paese
 */
export default function Filters({ filters, onChange, years }) {
    const set = (patch) => onChange({ ...filters, ...patch });
    const days = daysInMonth(filters.year, filters.month);

    const setMonth = (month) => set({ month, day: filters.day > daysInMonth(filters.year, month) ? 0 : filters.day });
    const setYear = (year) => set({ year, day: filters.day > daysInMonth(year, filters.month) ? 0 : filters.day });

    // se l'utente inverte le date le riordino
    const setRange = (from, to) => from <= to ? set({ from, to }) : set({ from: to, to: from });

    return (
        <div className="stFilters">
            <div className="stFilter stFilterYear">
                <span className="stFilterLabel">Anno</span>
                <Segmented label="Anno" options={years.map(y => ({ value: y, label: String(y) }))} value={filters.year} onChange={setYear} />
            </div>

            <label className="stFilter">
                <span className="stFilterLabel">Mese</span>
                <select className="form-select form-select-sm" value={filters.month} onChange={e => setMonth(Number(e.target.value))}>
                    {MONTHS.map((label, i) => <option key={label} value={i + 1}>{label}</option>)}
                </select>
            </label>

            <label className="stFilter">
                <span className="stFilterLabel">Giorno</span>
                <select className="form-select form-select-sm" value={filters.day} onChange={e => set({ day: Number(e.target.value) })}>
                    <option value={0}>Tutto il mese</option>
                    {Array.from({ length: days }, (_, i) => <option key={i + 1} value={i + 1}>{i + 1}</option>)}
                </select>
            </label>

            <div className="stFilter stFilterRange">
                <span className="stFilterLabel">Periodo</span>
                <div className="stRangeControls">
                    <Segmented label="Periodo" options={PRESETS} value={activePreset(filters.from, filters.to)} onChange={preset => set(presetRange(preset))} />
                    <div className="stDates">
                        <input type="date" className="form-control form-control-sm" aria-label="Dal" value={filters.from} max={filters.to} onChange={e => e.target.value && setRange(e.target.value, filters.to)} />
                        <span aria-hidden="true">–</span>
                        <input type="date" className="form-control form-control-sm" aria-label="Al" value={filters.to} min={filters.from} onChange={e => e.target.value && setRange(filters.from, e.target.value)} />
                    </div>
                </div>
            </div>
        </div>
    );
}
